const dohvatiSelektiraneKategorije = (kategorije: any) => {
  if (!kategorije) return null;

  const filtriraneKategorije = kategorije.filter(
    (kategorija: any) => kategorija.id
  );

  if (filtriraneKategorije.length === 0) return null;
  return filtriraneKategorije;
};

export default dohvatiSelektiraneKategorije;
